import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	
    {
        path: "/",
        meta: {
            title: '装饰辅材行业联盟'
        },
        redirect: "/index"
    },
	{
	    path: '/index',
	    name: 'index',
	    meta: {
	        title: '装饰辅材行业联盟',
	        isshowtabbar: true
	    },
	    component: () => import('@/views/baoming/index.vue')
	},
	{
	    path: '/img',
	    name: 'img',
	    meta: {
	        title: 'AI手机',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/img/img.vue')
	},
	{
	    path: '/baoming',
	    name: 'baoming',
	    meta: {
	        title: '装饰辅材行业联盟',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/baoming/baoming.vue')
	},
	{
	    path: '/vipbaoming',
	    name: 'vipbaoming',
	    meta: {
	        title: '装饰辅材行业联盟',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/baoming/vipbaoming.vue')
	},
	{
	    path: '/signin',
	    name: 'signin',
	    meta: {
	        title: '扫码签到',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/baoming/signin.vue')
	},
	{
	    path: '/selfsignin',
	    name: 'selfsignin',
	    meta: {
	        title: '自助签到',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/baoming/selfsignin.vue')
	},
	{
	    path: '/check',
	    name: 'check',
	    meta: {
	        title: '查座位',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/baoming/check.vue')
	},
	{
	    path: '/order',
	    name: 'order',
	    meta: {
	        title: '订单',
	        isshowtabbar: true
	    },
	    component: () => import('@/views/order/order.vue')
	},
	{
	    path: '/xsddDetail',
	    name: 'xsddDetail',
	    meta: {
	        title: '订单详情',
	        isshowtabbar: false
	    },
	    component: () => import('@/views/order/components/xsddDetail.vue')
	},
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    // if (to.path!='/check'&&to.path!='/selfsignin'&&to.path != "/order"&&to.path != "/index" && (JSON.parse(localStorage.getItem("isLogin")) == false || localStorage.getItem("isLogin") == null)) {
    //     next('/index');
    // }else{
		next();
	// }
})
export default router